import "@babel/polyfill";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./http/api";
import Antd from "ant-design-vue";
import rowSpin from "./components/rowSpin/rowSpin";
import pop from "./components/pop/pop";
import noData from "./components/noData/noData";
import showImg from "./components/showImg/showImg";
import userPower from "./components/userPower/userPower.vue";
import { Icon } from "ant-design-vue";
import Cookies from 'js-cookie'
import filters from './filters'


import VueParticles from 'vue-particles'
Vue.use(VueParticles)

const MyIcon = Icon.createFromIconfontCN({
    scriptUrl: "//at.alicdn.com/t/font_1135634_0u7pwmdw5c6g.js" // 在 iconfont.cn 上生成
});

Vue.component("MyIcon", MyIcon);

Vue.component("noData", noData);

Vue.component("Psn", userPower);

Vue.component("showImg", showImg);

Vue.prototype.$spin = pop;
Vue.prototype.$rowSpin = rowSpin;
Vue.use(Antd);

Vue.config.productionTip = false;

Vue.prototype.$api = api;
Vue.prototype.$cookie = Cookies
Vue.prototype.$EventBus = new Vue()

for (let key in filters) {
    Vue.filter(key, filters[key])
}

router.beforeEach((to, from, next) => {
    next();
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
